export default "/profile/images/viber_telephony.svg?c6178d181f9f46b8c89bf59224c7cb8a";